var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditorHeadingTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#8688A5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17.9932C6 18.5095 5.61728 18.9351 5.11733 18.9932L5 19C4.44772 19 4 18.5501 4 17.9932V6.00685C4 5.4905 4.38272 5.06493 4.88267 5.00677L5 5C5.55228 5 6 5.44995 6 6.00685V11H12V6.00685C12 5.4905 12.3827 5.06493 12.8827 5.00677L13 5C13.5523 5 14 5.44995 14 6.00685V17.9932C14 18.5095 13.6173 18.9351 13.1173 18.9932L13 19C12.4477 19 12 18.5501 12 17.9932V13H6V17.9932Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9983 14.9216C19.9983 13.9284 19.1414 13 17.9991 13C16.8569 13 16 13.8755 16 15.1833H17.2571C17.2571 14.7255 17.4859 14.3078 18 14.3078C18.4627 14.3078 18.7087 14.6441 18.7027 15.0559C18.7001 15.3235 18.5398 15.5725 17.88 16.2059L16.0009 18.0196V19H20V17.5098H18.4687L19.1671 16.7059C19.8098 15.9706 19.9983 15.5461 19.9983 14.9216Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorHeadingTwo);
export default __webpack_public_path__ + "static/media/editor-heading-two.3d7b28c3.svg";
export { ForwardRef as ReactComponent };